import {t} from "../../../i18n";
import ReservationButton from "../../../commonComponent/reservation/ReservationButton";
import ProgressiveImage from '../../../commonComponent/image/ProgressiveImage';
import {imageAssets} from '../../../assets/imageAssets';
import './couverture.css';
import restaurantInfo from "../../../data/restaurant.json";

const Couverture = () => {

    return (
        <section
            className="image-surface background-couverture"
            id="home"
        >
            <ProgressiveImage asset={imageAssets.couverture} priority sizes="(max-aspect-ratio: 3/2) 141vh, 100vw" alt={t("altCouverture")} className="surface-image" />

            <div className="hero-copy">
                <h1 className="hero-title">{restaurantInfo.name}</h1>
                <h2 className="hero-city">{restaurantInfo.ville}</h2>
                <h3 className="hero-description">{t("descriptionCouverture")}</h3>

                {/* Le geste que la page existe pour provoquer, a l'endroit ou le regard arrive.
                    Il vivait dans la barre du haut, ou il disputait la place au reste de la
                    navigation ; ici il ne dispute rien. C'est deja un lien telephonique au
                    premier rendu — voir `ReservationButton` — donc il n'attend pas le widget et
                    ne deplace aucune mise en page en devenant actif. */}
                <ReservationButton className="hero-cta" variant="on-image" />
            </div>

        </section>
    );
};

export default Couverture;
